import React from 'react';

import { useFullVariantByIdSsr } from '../../../../api/hooks/useFullVariantByIdSsr.hook';
import { useVariantDetailPage } from '../../../../api/hooks/useVariantDetailPage.hook';
import { User } from '../../../../api/models/user';
import { LinkVariants } from '../../../../utils/_enums/link-variants.enum';
import { TypographyVariantsEnum } from '../../../../utils/_enums/typeography-variants.enum';
import { getLanguage } from '../../../../utils/_helper/locale-helper';
import { Link } from '../../../_shared/link/link';
import TeaserCardProfilePicture
    from '../../../_shared/teaser-card-components/teaser-card-profile-picture/teaser-card-profile-picture';
import { Typography } from '../../../_shared/typography/typography';
import styles from './originator-list.module.scss';

const OriginatorList = () => {
    const data = useVariantDetailPage();

    const variant = useFullVariantByIdSsr();

    const originators = variant?.originators;

    const lang = getLanguage();

    const getLangDependentDescription = (originator: User, lang: string) => {
        switch (lang) {
            case 'de':
                return originator?.detailedDescriptionDe;
            case 'es':
                return originator?.detailedDescriptionEs;
            default:
                return originator?.detailedDescription;
        }
    }

    const renderOriginator = (originator: User) => {

        return (
            <div className={styles['originator-box']} key={originator.id}>
                <div className={styles['author-image-box']}>
                    <div className={styles['author-image']}>
                        <TeaserCardProfilePicture
                            profilePictureId={originator.id}
                        />
                    </div>
                </div>
                <div className={styles['content-box']}>
                    <Typography
                        variant={TypographyVariantsEnum.HEADING5}
                        element={'span'}
                    >{`${originator.firstName} ${originator.lastName}`}</Typography>

                    <Typography
                        className={styles['originator-description']}
                        variant={TypographyVariantsEnum.PARAGRAPH}
                    >
                        {getLangDependentDescription(originator, lang) ?? ''}
                    </Typography>

                    {originator.userWebsiteUrl ? (
                        <Link
                            href={originator.userWebsiteUrl ?? ''}
                            external={true}
                            variant={LinkVariants.STANDARD_LINK}
                            className={styles['originator-link']}
                        >
                            {originator.userWebsiteUrl ?? ''}
                        </Link>
                    ) : null}
                </div>
            </div>
        );
    };

    return (
        <div className={styles['originator-list']}>
            <Typography
                variant={TypographyVariantsEnum.HEADING3_BOLD}
                className={styles['originator-list-headline']}
            >
                {data?.productOriginators.headlineContent}
            </Typography>
            {originators &&
                originators.map((originator) => renderOriginator(originator))}
        </div>
    );
};

export default OriginatorList;
